<template>
  <v-app>
    <v-main style="background-color: white">
      <sds-layout :loading="loading" class="fill-height">
        <router-view />
      </sds-layout>
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>
import '@/styles/global.scss';
import { useLoader } from '@/composables/useLoader';

const { loading } = useLoader();
</script>
